import { Builder } from "@builder.io/react";
import { Compare1 } from "@/components/Compare";
import { registerMenuGroups, commonInputs} from "./helper";

const compareGroups = [
  {
    name: "Compare Components",
    items: [  
      { name: "Compare 1" },
    ]
  },
];

export const registerCompareComponents = () => {
  registerMenuGroups(compareGroups);  

  // Compare Components
  Builder.registerComponent(Compare1, {
    name: "Compare 1",
    friendlyName: "Compare 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      {
        name: "leftContent",
        type: "object",
        defaultValue: {
          title: "Title",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
          listItems: [
            {
              icon: "check",
              title: "Title 1",
              crossOut: false,
            },
            {
              icon: "check",
              title: "Title 2",
              crossOut: false,
            },
            {
              icon: "check",
              title: "Title 3",
              crossOut: true,
            },
          ],
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
          }),
          {
            name: "listItems",
            type: "list",
            subFields: [
              ...commonInputs.contentInputs({
                includeIcon: true,
                includeTitle: true,
              }),
              {
                name: "crossOut",
                type: "boolean",
                defaultValue: false,
              }
            ]
          },
          ...commonInputs.buttonInputs({excludeMicroCopy: false})
        ],
      },
      {
        name: "rightContent",
        type: "object",
        defaultValue: {
          title: "Title",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
          listItems: [
            {
              icon: "check",
              title: "Title 1",
              crossOut: false,
            },
            {
              icon: "check",
              title: "Title 2",
              crossOut: false,
            },
            {
              icon: "check",
              title: "Title 3",
              crossOut: true,
            },
          ],
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
          }),
          {
            name: "listItems",
            type: "list",
            subFields: [
              ...commonInputs.contentInputs({
                includeIcon: true,
                includeTitle: true,
              }),
              {
                name: "crossOut",
                type: "boolean",
                defaultValue: false,
              }
            ]
          },
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
        ],
      },
    ],
  });
};
